import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction } from '~/app/tracking/feld-m-types';

export type NbaClickEventParams = {
	eventAction: EventAction;
	nbaName: string;
	label: string;
	targetUrl: string;
	clickID: string;
	elementName: string;
	elementValue: string;
};

export class NbaClickEvent extends BaseEvent {
	constructor({ eventAction, nbaName, label, targetUrl, clickID, elementName, elementValue }: NbaClickEventParams) {
		super({
			eventInfo: {
				eventAction,
				eventName: `configurator (NBA) - click on ${nbaName}`,
			},
			attributes: {
				componentName: 'configurator-next-best-actions',
				label,
				targetURL: targetUrl,
				clickID,
				elementName,
				value: eventAction === EventAction.Download ? 'PDF' : '',
				relatedElements: [
					{
						elementName: 'cta',
						elementValue,
					},
				],
			},
		});
	}
}
